import BaseService from '../core/services/BaseService'
import Api from './Api'

class ClickDimensionService extends BaseService {
  async postForm(serializedFormData) {
    try {
      const response = await Api.post('/clickdimension/form', serializedFormData, {
        processData: false
      })
      console.log('ClickDimension form posted successfully:', response)
      return response
    } catch (error) {
      console.error('ClickDimension API error:', error)
      throw error
    }
  }
}

export default new ClickDimensionService()
